import { cn } from '@/lib/utils'

// 使い方のルール: docs/develop/client_ui/components/status.md

// ステータス表示のトーン。色は状態の意味にだけ使う（分類のような属性には付けない）。
// ok/progress/idle/off は v1 steelOrderLabels.tsx と同じ。ng は取込結果の失敗表示用
export type StatusTone = 'ok' | 'progress' | 'idle' | 'off' | 'ng'

const dotClasses: Record<StatusTone, string> = {
  ok: 'bg-emerald-500',
  progress: 'bg-amber-500',
  idle: 'bg-muted-foreground/40',
  // 「対象外」は未処理ではなく人が意図して外した状態。塗りつぶしのグレーだと
  // 「未登録」と見分けが付かないため、中空のドットで別種であることを示す（v1 と同じ理由）
  off: 'border border-muted-foreground/60 bg-transparent',
  ng: 'bg-destructive',
}

const labelClasses: Record<StatusTone, string> = {
  ok: 'text-foreground',
  progress: 'text-foreground',
  idle: 'text-muted-foreground',
  off: 'text-muted-foreground/70',
  ng: 'text-foreground',
}

// Only the dot carries color; text stays calm. Keeps the table readable
// without turning every cell into a colorful pill.
export function StatusDot({ tone, label }: { tone: StatusTone; label: string }) {
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm">
      <span className={cn('size-1.5 shrink-0 rounded-full', dotClasses[tone])} aria-hidden="true" />
      <span className={labelClasses[tone]}>{label}</span>
    </span>
  )
}
